import moment from 'moment';
import { shipment } from '../../../../../models/entities/shipment/shipment';
import { filterFieldsType } from '../../../../../state/ducks/allShipmentsPage/allShipmentsPage';
import filterShipments from '../../../../../state/ducks/allShipmentsPage/shipmentsGridFilter';
import { allowedCompany } from '../../../../../models/entities/user';
import { settings } from '../../../../../models/entities/shipment/shipment';
import { parseFilterFields, parsedFilterFieldType } from '../../utils';
import { userDetails } from '../../../../../state/ducks/users/users';

// Fields handled locally (not by the shared filterShipments)
const CUSTOM_FIELDS = ['fromETD', 'toETD', 'flightVoyage'];

export const applyConsolidationShipmentFilters = (shipments: shipment[], filterFields: filterFieldsType): shipment[] => {
    const standardFilters = filterFields.filter((f) => !CUSTOM_FIELDS.includes(f.field));
    const customFilters = filterFields.filter((f) => CUSTOM_FIELDS.includes(f.field));

    let filtered = filterShipments(shipments, standardFilters);

    customFilters.forEach((filter) => {
        if (filter.field === 'fromETD') {
            filtered = filtered.filter((s) => s.etd && moment(s.etd).isSameOrAfter(moment(filter.value), 'day'));
        }
        if (filter.field === 'toETD') {
            filtered = filtered.filter((s) => s.etd && moment(s.etd).isSameOrBefore(moment(filter.value), 'day'));
        }
        if (filter.field === 'flightVoyage' && typeof filter.value === 'string' && filter.value.trim()) {
            const q = filter.value.trim().toLowerCase();
            filtered = filtered.filter(
                (s) =>
                    (s.voyageNumber && s.voyageNumber.toLowerCase().includes(q)) ||
                    (s.vesselName && s.vesselName.toLowerCase().includes(q))
            );
        }
    });

    return filtered;
};

export const parseConsolidationFilterFields = (
    filterFields: filterFieldsType,
    allowedCompanies: allowedCompany[],
    shipmentSettings: settings,
    localization: any,
    businessPartners?: any[],
    users?: userDetails[]
): parsedFilterFieldType[] => {
    const standardFilters = filterFields.filter((f) => !CUSTOM_FIELDS.includes(f.field));
    const customFilters = filterFields.filter((f) => CUSTOM_FIELDS.includes(f.field));

    // parseFilterFields handles state, originStation, destinationStation, fromETA, toETA etc.
    const parsed = parseFilterFields(standardFilters, allowedCompanies, shipmentSettings, localization, businessPartners, users);

    customFilters.forEach(({ field, value }) => {
        if (field === 'fromETD') {
            parsed.push({ field, parsedValue: 'ETD from: ' + moment(value).format('DD/MM/YYYY'), originalValue: value });
        } else if (field === 'toETD') {
            parsed.push({ field, parsedValue: 'ETD to: ' + moment(value).format('DD/MM/YYYY'), originalValue: value });
        } else if (field === 'flightVoyage') {
            parsed.push({ field, parsedValue: 'Flight/Voyage: ' + value, originalValue: value });
        }
    });

    return parsed;
};

export const getConsolidationActiveFiltersCount = (filterFields: filterFieldsType | null) => filterFields?.length ?? 0;
